<template>
  <div class="dialog-wrap">
    <el-dialog title="内容详情"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="700px">
      <div class="title">{{questionTitle}}</div>
      <div class="content">{{answer_content}}</div>
      <div class="imgUrl"
           v-if="this.answer_img_urls.length !=0">
        <div v-for="(item,index) in answer_img_urls"
             :key="index"
             class="itemImg"><img :src="item"
               alt=""></div>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userAnswerDetail, questionDetail } from '@/api/senior'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detaiRow: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      detail: {},
      questionTitle: '',
      answer_content: '',
      answer_img_urls: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    detaiRow(val) {
      this.answer_img_urls =
        val.answer_img_urls != '' ? val.answer_img_urls.split(',') : []
      this.detail = val
      let data = {
        id: this.detail.id,
      }
      userAnswerDetail(data).then((res) => {
        let data = {
          id: res.question_id,
        }
        this.answer_content = res.answer_content
        questionDetail(data).then((res) => {
          this.questionTitle = res.question_title
        })
      })
    },
  },
  created() {},
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleSubmit() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  font-size: 18px;
  background: #ebeef5;
  border-radius: 4px 4px 0px 0px;
  padding: 10px 10px 10px !important;
}
.dialog-wrap {
  .title {
    font-weight: 500;
    font-size: 18px;
    color: #303133;
  }
  .content {
    margin-top: 22px;
    font-weight: 400;
    font-size: 14px;
    color: #303133;
  }
  .imgUrl {
    margin-top: 10px;
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    .itemImg {
      width: 100px;
      height: 100px;
      margin-right: 12px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
